import { Flex, Text } from "@/atoms"
import { useAppRegistrationTranslation } from "./useAppRegistrationTranslation"

export const ApplicationUser = () => {
  const t = useAppRegistrationTranslation()

  return (
    <Flex vertical gap={8}>
      <Text>{t("applicationUser")}</Text>
      <Text>{t("securityRole")}</Text>
      <Text type="secondary">{t("securityRoleNote")}</Text>
    </Flex>
  )
}
